import { Button, Image, Modal, Typography } from 'antd';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { Col, Row } from 'rsuite';

import { ToastVariant } from '../../../components/Toast/toast.model';
import { toastService } from '../../../components/Toast/toast.service';
import { useAuth } from '../../Auth/AuthContext';
import { AppRoutes } from '../../Routing/routing.model';

export const SPECIAL_OFFER_KEY = 'specialOffer100';
export const PROMOTION_APPLIED_KEY = 'promotionApplied100';
const { Paragraph, Title, Text } = Typography;

export const SpecialOffer100: React.FC = () => {
  const [cookie, setCookie] = useCookies([SPECIAL_OFFER_KEY, PROMOTION_APPLIED_KEY]);
  const [isVisible, setIsVisible] = useState(false);
  const { push } = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { showSignUpModal, isAuth } = useAuth();

  // Zapisz wartość cookie
  const setCookieValue = (key, value) => {
    setCookie(key, value, { path: '/', maxAge: 30 * 24 * 60 * 60 }); // ważne przez 30 dni
  };

  // Sprawdź warunki wyświetlenia modala
  useEffect(() => {
    // Sprawdź czy modal był już wcześniej zamknięty
    if (cookie[SPECIAL_OFFER_KEY] === 'OK') {
      return;
    }

    // Sprawdź czy mamy hash w URL lub jesteśmy na stronie innej niż główna
    const hasHash = location.hash !== '';
    const isSubpage = location.pathname !== '/';

    // Pokaż modal jeśli user przeszedł przez hash lub podstronę
    if (hasHash || isSubpage) {
      setIsVisible(true);
      setCookieValue(SPECIAL_OFFER_KEY, 'SHOW');
    }
  }, [location, cookie]);

  // Obsługa zamknięcia modala
  const handleOk = () => {
    setCookieValue(SPECIAL_OFFER_KEY, 'OK');
    setIsVisible(false);
  };

  // Przekierowanie do regulaminu
  const handleRegulationsClick = () => {
    push(AppRoutes.PROMOTION_REGULATION);
    handleOk(); // Zamykamy modal promocyjny, bo otworzy się regulamin
  };

  // Wyświetl toast z informacją o promocji
  const showPromotionToast = () => {
    // Sprawdź czy toast już wyświetlono wcześniej
    if (cookie[PROMOTION_APPLIED_KEY] !== 'SHOWN') {
      toastService.show(t('PROMOTION.TOAST_MESSAGE'), t('PROMOTION.TOAST_TITLE'), {
        variant: ToastVariant.SUCCESS,
        duration: 7000,
      });
      setCookieValue(PROMOTION_APPLIED_KEY, 'SHOWN');
    }
  };

  // Obsługa kliknięcia przycisku "Dodaj ofertę"
  const handleAddOfferClick = () => {
    handleOk();

    // Jeśli użytkownik nie jest zalogowany, pokaż modal rejestracji
    if (!isAuth) {
      showSignUpModal({
        title: t('PROMOTION.SPECIAL_OFFER'),
        onSuccess: () => {
          // Po zarejestrowaniu się, przekieruj do dodawania oferty
          push(AppRoutes.MOJA_TABLICA_UNSIGNED_OFFERS);
          showPromotionToast();
        },
      });
    } else {
      // Jeśli użytkownik jest już zalogowany, przekieruj bezpośrednio
      push(AppRoutes.MOJA_TABLICA_UNSIGNED_OFFERS);
      showPromotionToast();
    }
  };

  return (
    <>
      <Modal
        open={isVisible}
        title={
          <Title level={3} className="text-center">
            {t('PROMOTION.SPECIAL_OFFER')}
          </Title>
        }
        onCancel={handleOk}
        width={800}
        footer={null}
        className="promotion-modal">
        <div className="p-4">
          <Row className="mb-6">
            <Col xs={24} md={12} className="flex items-center justify-center mb-4 md:mb-0">
              <Image
                src="/images/insurance-promo.svg"
                alt="Promocja ubezpieczenia"
                fallback="data:image/png;base64,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"
                preview={false}
                className="max-w-xs"
              />
            </Col>
            <Col xs={24} md={12}>
              <Title level={4} className="mb-4">
                {t('PROMOTION.FREE_INSURANCE')}
              </Title>
              <Paragraph className="text-lg">{t('PROMOTION.INTRO_TEXT')}</Paragraph>
              <Paragraph className="text-lg">{t('PROMOTION.PROTECTION_TEXT')}</Paragraph>
              <div className="mt-4">
                <Text type="secondary" className="text-sm">
                  {t('PROMOTION.TIME_LIMITED')}
                </Text>
              </div>
            </Col>
          </Row>

          <Row className="mt-8 mb-4">
            <Col xs={24}>
              <Title level={5}>{t('PROMOTION.WHY_WORTH_IT')}</Title>
              <ul className="list-disc pl-5 mt-2">
                <li className="mb-1">{t('PROMOTION.BENEFIT_1')}</li>
                <li className="mb-1">{t('PROMOTION.BENEFIT_2')}</li>
                <li className="mb-1">{t('PROMOTION.BENEFIT_3')}</li>
                <li className="mb-1">{t('PROMOTION.BENEFIT_4')}</li>
              </ul>
            </Col>
          </Row>

          <Row className="mt-6 pt-4 border-t border-gray-200">
            <Col xs={24} className="flex flex-col md:flex-row justify-between items-center">
              <Button onClick={handleRegulationsClick} type="link" className="mb-3 md:mb-0">
                {t('PROMOTION.REGULATION_LINK')}
              </Button>
              <div>
                <Button onClick={handleOk} className="mr-3">
                  {t('PROMOTION.CLOSE')}
                </Button>
                <Button onClick={handleAddOfferClick} type="primary" size="large">
                  {t('PROMOTION.ADD_OFFER_CTA')}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};
